import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';

const isTouchDevice = () => {
    if (typeof window === 'undefined') {
        return false;
    }

    return 'ontouchstart' in window || (window.navigator && window.navigator.maxTouchPoints > 0);
};

if (Dropdown && Dropdown.prototype && !Dropdown.prototype.__touchResizePatchApplied) {
    const originalBindResizeListener = Dropdown.prototype.bindResizeListener;

    // PrimeReact hides dropdown overlay on resize; mobile keyboard open emits resize.
    Dropdown.prototype.bindResizeListener = function() {
        if (!isTouchDevice()) {
            return originalBindResizeListener.call(this);
        }

        if (!this.resizeListener) {
            this.resizeListener = () => {
                if (this.state && this.state.overlayVisible && this.alignPanel) {
                    this.alignPanel();
                }
            };

            window.addEventListener('resize', this.resizeListener);
        }
    };

    Dropdown.prototype.__touchResizePatchApplied = true;
}

if (MultiSelect && MultiSelect.prototype && !MultiSelect.prototype.__touchResizePatchApplied) {
    const originalBindResizeListener = MultiSelect.prototype.bindResizeListener;

    // PrimeReact hides multiselect overlay on resize; mobile keyboard open emits resize.
    MultiSelect.prototype.bindResizeListener = function() {
        if (!isTouchDevice()) {
            return originalBindResizeListener.call(this);
        }

        if (!this.resizeListener) {
            this.resizeListener = () => {
                if (this.state && this.state.overlayVisible && this.alignPanel) {
                    this.alignPanel();
                }
            };

            window.addEventListener('resize', this.resizeListener);
        }
    };

    MultiSelect.prototype.__touchResizePatchApplied = true;
}
